import { Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { CompanyComponent } from './pages/company/company.component';
import { CompaniesComponent } from './pages/companies/companies.component';

export const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'companies', component: CompaniesComponent },
  { path: 'company/:id', component: CompanyComponent },
  { path: '**', redirectTo: '/', pathMatch: 'full' }, // redirect to `first-component`
];
